import { QueryClient } from 'react-query';
import { isCosneticsAuthenticationError } from 'redux/database/cosneticsAuthentication';

export const shouldRetryQuery = (
  failureCount: number,
  error: unknown
): boolean =>
  !isCosneticsAuthenticationError(error) && failureCount < 3;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: shouldRetryQuery
    }
  }
});
